import React, { Component } from 'react';
import './iamExAcUserPermissions.css';
import IamExAuditTableRow from './iamExAcAuditTableRow/iamExAcAuditTableRow.js';

class IamExContent extends Component {

  state = {

  };

  componentDidMount() {

  };

  render() {

    return (
      <div className="IamExContentPage">
        <table className="IamExAudit">
          <tbody>
            <tr>
              <th>
                                Username
              </th>
              <th>
                                Account
              </th>
              <th>
                                Account ID
              </th>
              <th>
                                MFA
              </th>
              {this.props.headers.map(header => {
                return <th key={header}>{header}</th>;
              })}
            </tr>
            {this.props.iamAuditUsers.map(user => {
              return <IamExAuditTableRow key={user.UserId} user={user} headers={this.props.headers}/>;
            })}
          </tbody>
        </table>
      </div>
    );
  };

};

export default IamExContent;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExActions/iamExAcUserPermissions/iamExAcUserPermissions.js